import {
    commonNewClassnames
} from '@common';

const prefix = 'student';

export const newClassnames = (name) => commonNewClassnames(`${prefix}-${name}`);

export const routerPaths = {
    home: `/${prefix}`,
    privacyStatement: `/${prefix}/privacystatement`,
    termsOfUse: `/${prefix}/termsofuse`,
    FAQ:`/${prefix}/FAQ`
};